import { endOfDay, startOfDay } from "date-fns";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";

import "components/DatePicker/DatePicker.scss";
import { CustomDatePickerInput } from "components/TableFilters/TableDatePickerInput";

type TableDatePickerProps = {
  dateEnd: Date | null;
  dateStart: Date | null;
  inputClassName: string;
  clearable?: boolean;
  onChange: (dates: [Date | null, Date | null]) => void;
};

export const TableDatePicker = ({ dateStart, dateEnd, onChange, inputClassName, clearable = false }: TableDatePickerProps) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([dateStart, dateEnd]);

  const [startDate, endDate] = dateRange;
  const handleClear = () => {
    setDateRange([null, null]);
    onChange([null, null]);
  };
  const handleChange = (dates: [Date | null, Date | null]) => {
    setDateRange(dates);

    if (dates[1]) {
      onChange([startOfDay(dates[0] ?? new Date()), endOfDay(dates[1] ?? new Date())]);
      setIsOpen(false);
    }
  };

  return (
    <DatePicker
      calendarClassName="CalendarDatepicker"
      open={isOpen}
      popperPlacement="bottom-start"
      selectsRange
      onInputClick={() => setIsOpen(prev => !prev)}
      onClickOutside={(e: MouseEvent) => {
        if (e.target instanceof HTMLElement && e.target.closest(`.${inputClassName}`)) return;
        setIsOpen(false);
      }}
      startDate={startDate || undefined}
      endDate={endDate || undefined}
      onChange={handleChange}
      customInput={<CustomDatePickerInput inputClassName={inputClassName} />}
      selected={endDate || new Date()}
    >
      {clearable && (
        <div className="react-datepicker-clear-date-container">
          <Button
            content={t("v8_clear_date_range", "Clear date range")}
            icon="calendar"
            labelPosition="left"
            onClick={handleClear}
            className="react-datepicker-clear-date-button"
          />
        </div>
      )}
    </DatePicker>
  );
};
